import { render, staticRenderFns } from "./BaseImage.vue?vue&type=template&id=1bfd5acb&scoped=true"
import script from "./BaseImage.vue?vue&type=script&lang=js"
export * from "./BaseImage.vue?vue&type=script&lang=js"
import style0 from "./BaseImage.vue?vue&type=style&index=0&id=1bfd5acb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd5acb",
  null
  
)

export default component.exports